var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gg-sigin mt-3"},[_c('div',{attrs:{"id":"button_google"}}),_c('div',{staticClass:"error-message text-center",attrs:{"id":"error"}},[_vm._v(_vm._s(_vm.$t(_vm.error.message)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }